import { useCallback, useState } from 'react'
import { compose } from 'recompose'
import Formsy from 'formsy-react'

import { stripDocumentNumber } from 'shared/components/DocumentDataFields/utils'
import DocumentDataFields from 'shared/components/DocumentDataFields'
import Modal from 'shared/components/Modal'

import { logout } from 'auth/actions'
import { withTranslate } from 'i18n/utils'

import Button from '@components/Button'
import ErrorMessage from '@components/ErrorMessage'
import useRequestPending from 'shared/hooks/useRequestPending'

import PhoneInput from './PhoneInput'
import { updateAccount } from '../actions'
import { updateAccountPendingSelector } from '../selectors'

import { userDetailsSelector } from 'auth/selectors'

const AccountFormModal = ({ translate: t, onSuccess, userDetails, updateAccount, updateAccountPending, logout }) => {
    const [isValid, setValid] = useState(false)
    const { error, isLoading } = useRequestPending(updateAccountPending, onSuccess)

    const { phone, document: { type } = {} } = userDetails

    const onSubmit = useCallback(formData => {
        const formDataNormalized = {
            ...formData,
            document: {
                type: formData.documentType,
                number: stripDocumentNumber(formData.documentNumber),
            },
        }

        const { billingAddress, deliveryAddress, firstName, lastName, phone, emailAddress, document } = {
            ...userDetails,
            ...formDataNormalized,
            document: {
                ...userDetails.document,
                ...formDataNormalized.document,
            },
        }

        const updatedData = {
            billingAddress,
            deliveryAddress,
            firstName,
            lastName,
            phone,
            emailAddress,
            document,
        }

        updateAccount(updatedData)
    }, [])

    const onValid = () => setValid(true)
    const onInvalid = () => setValid(false)

    return (
        <Modal size="small" header={<T>dashboard.accountform.reminder.header</T>}>
            <Formsy onValid={onValid} onInvalid={onInvalid} onSubmit={onSubmit}>
                {!type && <DocumentDataFields fieldClassName="col-12" />}
                {!phone && (
                    <div className="mb-3">
                        <PhoneInput value={phone} />
                    </div>
                )}

                <div className="d-flex justify-content-between">
                    <Button type="submit" isLoading={isLoading} disabled={isLoading || !isValid}>
                        {t('form.submit.button')}
                    </Button>

                    <Button type="button" btnStyle="link" disabled={isLoading} onClick={logout}>
                        {t('header.user.logout')}
                    </Button>
                </div>

                {error && <ErrorMessage messages={[error]} className="mt-3" />}
            </Formsy>
        </Modal>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            userDetails: userDetailsSelector,
            updateAccountPending: updateAccountPendingSelector,
        }),
        {
            updateAccount,
            logout,
        }
    ),
    withTranslate
)(AccountFormModal)
